<div class="page-breadcrumb" *ngIf="read==true || write==true || delete ==true">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Banner Management</h4>
        </div>

    </div>
</div>

<!-- <div  style="margin-top: 37px;" *ngIf="write!=true && read!=true && delete!=true ">
   
    <div class="box">
        <div class="text-center">
          
            <p class="text-muted my-4" style="color:#353556!important;font-size: x-large;font-weight: 600;font-family: initial;">YOU DON'T HAVE ANY PERMISSION TO ACCESS ON THIS PAGE.</p>
            
        </div>
    </div>
</div> -->


<div style="display: block;Width:13%;margin-left: 30px;" *ngIf="write==true">
    <div class="mt-3" >
        <a *ngIf="!show" href="javascript:void(0)" (click)="addBanner()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addBanner()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </div>
</div>


<div *ngIf="show">
    <div style="margin-top:-22px;">

        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #banner="ngForm" novalidate>
                                <div class="form-body">
                                    <h5 class="card-title"> Banner Management</h5>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> Screen Name</label>
                                                <!-- <input type="text" id="screenName" required #screenName="ngModel"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)"
                                                    name="screenname" placeholder="Screen Name" class="form-control"
                                                    [(ngModel)]="bannerAddObj.screenName" minlength="3" maxlength="30"
                                                    pattern="^[^\d\W]+( [^\d\W]+)*$"> -->
                                                <select class="form-control" id="notificationType" required
                                                    #notificationType="ngModel" name="notificationType"
                                                    [(ngModel)]="bannerAddObj.screenName"
                                                    data-placeholder="Choose a Notification Type" tabindex="1">
                                                    <option value="HomeScreen">Home Screen </option>

                                                </select>
                                                <span class="text-danger" [hidden]="!screenName.errors.required"
                                                    *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">*This
                                                    Field is Required
                                                </span>
                                                <span class="text-danger" [hidden]="!screenName.errors?.pattern"
                                                    *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">
                                                    First Name Should Start With Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!screenName.errors?.minlength || screenName.errors.pattern"
                                                    *ngIf="screenName.errors && (screenName.touched || screenName.dirty)">First
                                                    Name Should Be Min 3 Characters</span> </div>
                                        </div>

                                        <div class="col-md-3">
                                            <h5 class="card-title m-t-20"> <span class="text-danger">*</span>
                                                Browse Images</h5>


                                            <div class="btn btn-info waves-effect waves-light" style="width: 221px;">
                                                <input type="file" id="container" multiple
                                                    accept="image/gif, image/jpeg, image/png"
                                                    (change)="fileChangeEvent($event)" required #images="ngModel"
                                                    name="images" [(ngModel)]="bannerAddObj.images" class="upload">
                                            </div>
                                            <span class="text-danger" [hidden]="!images.errors.required"
                                                *ngIf="images.errors && (images.touched || images.dirty)">*This
                                                Field is required
                                            </span>
                                            <!-- <input type="file" ng2FileSelect [uploader]="uploader" multiple /><br /> -->




                                        </div>
                                        <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                            style="margin-left: 43px;"> <br />

                                    </div>


                                    <!--/row-->
                                    <!-- <div class="row">

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Image Sequence</label>
                                                <input type="text" id="sequence" required
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    class="form-control" name="sequence" #sequence="ngModel"
                                                    [(ngModel)]="bannerAddObj.sequence " placeholder="Image Sequence">
                                                <span class="text-danger" [hidden]="!sequence.errors.required"
                                                    *ngIf="sequence.errors && (sequence.touched || sequence.dirty)">*This
                                                    Field is required
                                                </span>
                                            </div>
                                        </div>
                                    </div> -->
                                    <!--/row-->

                                </div>
                                <br>
                                <br>
                                <br>
                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #353556;color:white"
                                        [disabled]="!banner.valid" (click)="saveBanner()" class="btn">
                                        <i class="fa fa-check"></i> Submit</button>&nbsp;&nbsp;
                                    <a type="button" class="btn btn-dark" style="color: white;"
                                        (click)="addBanner()">Cancel</a>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>

    </div>
</div>
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid">

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">

                            <div>
                                <div>
                                    <mat-form-field>

                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                       
                                        <ng-container matColumnDef="screenName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Screen Name</th>
                                            <td *matCellDef="let row">
                                                {{row.screenName}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="bannerImages">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Banner Images</th>
                                            <td *matCellDef="let row">
                                                <a target="blank" href="{{myurl+'Misc/Images/bannerImages/'+row._id}}">View</a>

                                               

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Banner Status
                                            </th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfModification">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified Date
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfModification|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Action">
                                            <th mat-header-cell *matHeaderCellDef>Action</th>

                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true && write !=true && delete !=true"
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    don't have permissions to Edit/Delete</p>

                                                <ul class="list-group list-group-flush"
                                                    *ngIf=" write==true||delete==true">
                                                    <li class="list-group-item  friend-list mb-2">
                                                      
                                                        <div class="dropdown show  list-block">
                                                            <a class="userDropdown" href="#" role="button"
                                                                 id="userDropdown"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                                <button class="dropdown-item" data-toggle="modal"
                                                                    *ngIf=" write==true" data-target="#responsive"
                                                                    (click)="getBannerById(row._id)">
                                                                    <i class="fa fa-address-card"
                                                                        aria-hidden="true"></i>&nbsp;&nbsp;Edit</button>
                                                                <button class="dropdown-item" *ngIf="delete==true"
                                                                    (click)="deleteByBannerId(row._id)">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                                <div *ngIf="write==true">
                                                                    <mat-slide-toggle
                                                                        (change)="onChange($event,row._id)"
                                                                        [checked]="row.status">
                                                                        <span *ngIf="row.status==false">
                                                                            In Active</span>
                                                                        <span *ngIf="row.status==true">
                                                                            Active</span>
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- ============================================================== -->

<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Banner Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #bannerUpdate="ngForm" novalidate>
                    <div class="form-body">

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> Screen Name</label>
                                    <input type="text" id="screenName" readonly required #screenName="ngModel"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)"
                                        name="screenname" placeholder="Screen Name" class="form-control"
                                        [(ngModel)]="bannerUpdateObj.screenName" minlength="3" maxlength="30"
                                        pattern="^[^\d\W]+( [^\d\W]+)*$">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Screen ID </label>
                                    <input type="tel" name="screenid" readonly placeholder="Screen Id"
                                        class="form-control" id="screenid" required
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        #screenid="ngModel" [(ngModel)]="bannerUpdateObj.screenId">
                                </div>
                            </div>
                            <!--/span-->
                        </div>

                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="card-title m-t-20">
                                    Browse Images</h5>


                                <div class="btn btn-info waves-effect waves-light">
                                    <input type="file" id="container" accept="image/gif, image/jpeg, image/png"
                                        (change)="fileChangeEventUpdate($event)" #images="ngModel" name="images"
                                        [(ngModel)]="bannerUpdateObj.images" class="upload"></div>
                                <!-- <span class="text-danger" [hidden]="!images.errors.required"
                                    *ngIf="images.errors && (images.touched || images.dirty)">*This
                                    Field is required
                                </span> -->
                            </div>
                            <img width="45.25em" height="46.25em" [src]="picUpdate" height="150" width="200px"
                                style="margin-left: 43px;"> <br />

                            <!--/span-->
                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Image Sequence</label>
                                    <input type="text" id="sequence" required
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        class="form-control" name="sequence" #sequence="ngModel"
                                        [(ngModel)]="bannerUpdateObj.sequence " placeholder="Image Sequence">
                                    <span class="text-danger" [hidden]="!sequence.errors.required"
                                        *ngIf="sequence.errors && (sequence.touched || sequence.dirty)">*This
                                        Field is required
                                    </span>
                                </div>
                            </div> -->
                            <!--/span-->
                        </div>
                        <!--/row-->

                    </div>
                    <br>
                    <br>
                    <br>
                    <div class="form-actions m-t-40">
                        <button type="submit" data-dismiss="modal" style="background-color: #353556;color:white"
                          (click)="updateBanner()" class="btn">
                            <i class="fa fa-check"></i> Update</button>&nbsp;&nbsp;
                        <a type="button" class="btn btn-dark" style="color: white;" data-dismiss="modal">Cancel</a>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>